// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-48b894cf] {\n  font-family: var(--interfaceFontTypeface, inherit);\n  color: var(--interfaceFontColor, var(--text-gray-400));\n  font-weight: var(--interfaceFontWeight, 700);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
